<template>
  <div class="wrapper">
    <Loading :active.sync="loading" :lock-scroll="true" :is-full-page="true" :opacity="0.7" color="#F58549"></Loading>

    <div class="wrapper fadeInDown" >
      <div id="formContent">

        <div class="fadeIn first">
          <img style="width: 20%; margin-top: 2%;" src="../img/bees/bine.png"/>
        </div>

        <v-form>
          <p style="color: #772F1A"><strong>{{errorMessage}}</strong></p>
          <v-text-field
            v-model="credentials.email"
            style="margin: 5px 20px 20px 20px;"
            type="text"
            class="fadeIn"
            label="E-mail"
            ></v-text-field>

          <v-text-field
            v-model="credentials.password"
            style="margin: 5px 20px 20px 20px;"
            :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
            :type="showPass ? 'text' : 'password'"
            label="Parola"
            @click:append="showPass = !showPass"
            @keyup.enter="submit()"
           ></v-text-field>
        </v-form>

        <div class="container">
          <button type="button" class="buton btn" @click="submit()">Log In</button>
        </div>

        <div class="container" style="margin-top: -3vh;font-size: 13px;">
          <router-link style="color:black;" to="/signup">
            <u> Nu ai cont? Crează aici </u>
          </router-link>
        </div>

        <div class="container" style="margin-top: -3vh;font-size: 13px;">
          <a><u @click="$refs.forgotPassword.open()"> Am uitat parola </u></a>
        </div>
      </div>
    </div>

    <sweet-modal ref="alertVerifyMail" icon="warning">
      <div style="margin-bottom: 2vh;">Adresa de email nu a fost verificată!</div>
      <div style="margin-bottom: 2vh;">Ți-am trimis un e-mail la {{credentials.email}}. Pentru a putea accesa contul trebuie să accesezi link-ul pe care îl conține.</div>
      <div style="margin-bottom: 2vh;">Nu uita să verifici și în Spam dacă nu îl găsești!</div>

      <div>
        <button type="button" class="buton btn"  @click="$refs.alertVerifyMail.close()">Am înțeles</button>
        <button type="button" class="buton btn" style="margin-left: 2vh;" @click="sendNewMail()">Trimite-mi un nou mail.</button>
      </div>
    </sweet-modal>

    <sweet-modal ref="forgotPassword">
      <div style="margin-bottom: 2vh;">
        <p>Te rugăm să introduci adresa de e-mail a contului.</p>
        <p>Îți vom trimite un link pentru resetarea parolei.</p>
      </div>

      <v-text-field
        v-model="credentials.email"
        style="margin: 5px 20px 20px 20px;"
        type="text"
        class="fadeIn"
        label="E-mail"
        ></v-text-field>

      <button type="button" class="buton btn" @click="requestReset()">Trimite</button>
    </sweet-modal>

    <sweet-modal ref="notifyMailSent" icon="success">
      <div style="margin-bottom: 2vh;">Mail-ul a fost trimis.</div>
      <div style="margin-bottom: 2vh;">Nu uita să verifici și în Spam dacă nu îl găsești!</div>

      <div>
        <button type="button" class="buton btn" @click="$refs.notifyMailSent.close()">OK</button>
      </div>
    </sweet-modal>

    <sweet-modal ref="notifyMailFailed" icon="error">
      <div style="margin-bottom: 2vh;">{{mailError}}</div>

      <div>
        <button type="button" class="buton btn" @click="$refs.notifyMailFailed.close()">OK</button>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { SweetModal } from 'sweet-modal-vue'
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
    SweetModal,
    Loading
  },

  data: () => ({
    credentials: {
      email: '',
      password: ''
    },
    errorMessage: '',
    mailError: '',
    showPass: false,
    loading: false,
    mailSent: false,
  }),

  methods: {
    ...mapActions({
      login: 'auth/login'
    }),

    submit () {
      this.loading = true
      this.errorMessage = ' '
      this.login(this.credentials).then(() => {
        this.loading = false
        this.$router.replace({ name: 'main' })
      }).catch((e) => {
        this.loading = false
        if (e.response.status === 401) {
          this.errorMessage = 'Ai introdus greșit adresa și/sau parola!'
        } else if (e.response.status === 403){
          this.$refs.alertVerifyMail.open()
        } else {
          this.errorMessage = 'Nu s-a putut conecta.'
        }
      })
    },

    sendNewMail() {
      this.loading = true
      this.$refs.alertVerifyMail.close()

      axios.post('auth/send_new_confirm_mail', {
        email: this.credentials.email
      }).then(() => {
        this.loading = false
        this.$refs.notifyMailSent.open()
      }).catch((e) => {
        this.loading = false
        console.log(e)
        this.mailError = "Ceva nu a mers bine."
        this.$refs.notifyMailFailed.open()
      })
    },

    requestReset() {
      this.loading = true
      this.$refs.forgotPassword.close()

      axios.post('auth/forgot_password', {
        email: this.credentials.email
      }).then(() => {
        this.loading = false
        this.$refs.notifyMailSent.open()
      }).catch((e) => {
        if(e.response.status == 401){
          this.mailError = 'Nu există un cont asociat acestei adrese.'
        } else {
          console.log(e)
          this.mailError = 'Ceva nu a mers bine'
        }

        this.loading = false
        this.$refs.notifyMailFailed.open()
      })
    }

  }
}
</script>

<style scoped>
.body {
  background-color: #F2A65A;
  height: 100vh;
}

.container {
  margin-top: 1vh;
  margin-bottom: 2vh;
}

/* STRUCTURE */
.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
}

#formContent {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: 90%;
  max-width: 450px;
  position: relative;
  padding: 0px;
  -webkit-box-shadow: 0 10px 10px 0 rgba(0,0,0,0.3);
  box-shadow: 0 10px 10px 0 rgba(0,0,0,0.3);
  text-align: center;
}

#formFooter {
  background-color: #f6f6f6;
  border-top: 1px solid #dce8f1;
  padding: 25px;
  text-align: center;
  -webkit-border-radius: 0 0 10px 10px;
  border-radius: 0 0 10px 10px;
}

/* TABS */
h2.inactive {
  color: #cccccc;
}

h2.active {
  color: #0d0d0d;
  border-bottom: 2px solid #F58549;
}

/* Form Inputs */


/* ANIMATIONS */
/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

@keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}

/* Simple CSS3 Fade-in Animation */
@-webkit-keyframes fadeIn { from { opacity:0; } to { opacity:1; } }
@-moz-keyframes fadeIn { from { opacity:0; } to { opacity:1; } }
@keyframes fadeIn { from { opacity:0; } to { opacity:1; } }

.fadeIn {
  opacity:0;
  -webkit-animation:fadeIn ease-in 1;
  -moz-animation:fadeIn ease-in 1;
  animation:fadeIn ease-in 1;

  -webkit-animation-fill-mode:forwards;
  -moz-animation-fill-mode:forwards;
  animation-fill-mode:forwards;

  -webkit-animation-duration:1s;
  -moz-animation-duration:1s;
  animation-duration:1s;
}

.fadeIn.first {
  -webkit-animation-delay: 0.4s;
  -moz-animation-delay: 0.4s;
  animation-delay: 0.4s;
}

.fadeIn.second {
  -webkit-animation-delay: 0.6s;
  -moz-animation-delay: 0.6s;
  animation-delay: 0.6s;
}

.fadeIn.third {
  -webkit-animation-delay: 0.8s;
  -moz-animation-delay: 0.8s;
  animation-delay: 0.8s;
}

.fadeIn.fourth {
  -webkit-animation-delay: 1s;
  -moz-animation-delay: 1s;
  animation-delay: 1s;
}

/* OTHERS */
*:focus {
    outline: none;
}

#icon {
  width:60%;
}

</style>
